import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const svgClass = 'w-full h-12 text-[#1C1C1C] fill-none stroke-current stroke-[1.5]';
const CarIcons = {
  SUV: () => <svg viewBox="0 0 110 48" className={svgClass} data-id="element-47" data-mp="cvadnobvl7yp">
      {/* Wheels - large with spokes for off-road look */}
      <circle cx="24" cy="37" r="7" data-id="element-48" data-mp="7x8smxuw2ykl" />
      <circle cx="24" cy="37" r="4" data-id="element-49" data-mp="7w7fmnubc208" />
      <line x1="24" y1="30" x2="24" y2="33" strokeWidth="0.6" data-id="element-50" data-mp="2x49f02ljpqo" />
      <line x1="24" y1="41" x2="24" y2="44" strokeWidth="0.6" data-id="element-51" data-mp="2ynseyfn0ew5" />
      <line x1="17" y1="37" x2="20" y2="37" strokeWidth="0.6" data-id="element-52" data-mp="3uaz7oen8iqiy" />
      <line x1="28" y1="37" x2="31" y2="37" strokeWidth="0.6" data-id="element-53" data-mp="3qagdwf1s7ae4" />
      <circle cx="84" cy="37" r="7" data-id="element-54" data-mp="3qaoqe5tzsdos" />
      <circle cx="84" cy="37" r="4" data-id="element-55" data-mp="3lbc1zgnh2yk3" />
      <line x1="84" y1="30" x2="84" y2="33" strokeWidth="0.6" data-id="element-56" data-mp="3lcexk1vqpp6c" />
      <line x1="84" y1="41" x2="84" y2="44" strokeWidth="0.6" data-id="element-57" data-mp="3gbzk7abgkhod" />
      <line x1="77" y1="37" x2="80" y2="37" strokeWidth="0.6" data-id="element-58" data-mp="3gbhgxtqdp36y" />
      <line x1="88" y1="37" x2="91" y2="37" strokeWidth="0.6" data-id="element-59" data-mp="3be7fffppt12r" />
      {/* Body - Toyota SW4 GR profile: muscular, tall, angular */}
      <path d="M6 37 H17 M31 37 H77 M91 37 H100 C102 37 103 35 103 33 L103 22 C103 20 102 19 100 19 L92 19 L92 10 C92 8 90 6 88 6 L66 6 L44 6 C40 6 36 8 33 12 L26 19 L12 19 C9 19 7 20 6 22 L4 28 C3 30 4 33 5 35 L6 37 Z" data-id="element-60" data-mp="2gmivvwadzsn" />
      {/* Muscular wheel arches */}
      <path d="M14 37 C14 31 19 27 24 27 C29 27 34 31 34 37" strokeWidth="1.2" data-id="element-61" data-mp="3tnfjoyn63wwn" />
      <path d="M74 37 C74 31 79 27 84 27 C89 27 94 31 94 37" strokeWidth="1.2" data-id="element-62" data-mp="l85gfn7jklna" />
      {/* Windows - two sections with thick D-pillar */}
      <path d="M35 13 L42 7 L65 7 L65 18 L30 18 Z" strokeLinejoin="round" data-id="element-63" data-mp="ba9araxdiiwk" />
      <path d="M65 7 L88 7 L88 18 L65 18" strokeLinejoin="round" data-id="element-64" data-mp="b9zl5og8qdre" />
      <line x1="52" y1="7" x2="52" y2="18" data-id="element-65" data-mp="g8au7wypok8k" />
      {/* Roof rails */}
      <line x1="40" y1="4" x2="86" y2="4" strokeWidth="1" data-id="element-66" data-mp="2w0q7xx2ny5xl" />
      <line x1="42" y1="6" x2="42" y2="4" strokeWidth="0.8" data-id="element-67" data-mp="2vz5e69o6ar0s" />
      <line x1="60" y1="6" x2="60" y2="4" strokeWidth="0.8" data-id="element-68" data-mp="310mdi0r0e5f9" />
      <line x1="78" y1="6" x2="78" y2="4" strokeWidth="0.8" data-id="element-69" data-mp="17gugyxjhqrsk" />
      {/* Side mirror */}
      <path d="M28 16 L25 13 L25 16" data-id="element-70" data-mp="17inf1og1g3oy" />
      {/* GR aggressive front bumper */}
      <path d="M6 28 L10 24 L12 24" strokeWidth="1" data-id="element-71" data-mp="12ij74mt74hac" />
      <line x1="5" y1="32" x2="10" y2="32" strokeWidth="0.8" data-id="element-72" data-mp="xqhqypswq6f1" />
      {/* Front fog light / intake */}
      <rect x="7" y="24" width="4" height="2" rx="0.5" strokeWidth="0.6" data-id="element-73" data-mp="sspwpp4si87o" />
      {/* Side step */}
      <line x1="34" y1="35" x2="74" y2="35" strokeWidth="0.8" data-id="element-74" data-mp="nt3k9hwscvzx" />
      {/* Door lines */}
      <line x1="52" y1="18" x2="52" y2="33" strokeWidth="0.6" data-id="element-75" data-mp="jqqfavpv5247" />
      {/* Door handles */}
      <line x1="42" y1="23" x2="47" y2="23" data-id="element-76" data-mp="erwzgwn3sz0v" />
      <line x1="58" y1="23" x2="63" y2="23" data-id="element-77" data-mp="esowmbwcn4t9" />
      {/* Rear bumper */}
      <line x1="98" y1="32" x2="102" y2="32" strokeWidth="0.8" data-id="element-78" data-mp="9tvhyg5bt7ri" />
      {/* Rear light */}
      <rect x="99" y="22" width="2" height="5" rx="0.5" strokeWidth="0.6" data-id="element-79" data-mp="296psqp0ildpn" />
      {/* Front headlight */}
      <path d="M8 20 L12 19 L12 22" strokeWidth="0.8" data-id="element-80" data-mp="246tp4qvqboam" />
      {/* Body line / character line */}
      <line x1="14" y1="26" x2="96" y2="26" strokeWidth="0.5" data-id="element-81" data-mp="2br5maj69h9bd" />
    </svg>,
  Truck: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-82" data-mp="2gp75d43ot8mu">
      {/* Wheels */}
      <circle cx="24" cy="33" r="6" data-id="element-83" data-mp="2lgfh46shp636" />
      <circle cx="24" cy="33" r="3" data-id="element-84" data-mp="2lg5samj6l4z2" />
      <circle cx="78" cy="33" r="6" data-id="element-85" data-mp="2lh7arc2j0tqt" />
      <circle cx="78" cy="33" r="3" data-id="element-86" data-mp="2qf8vs2jij34x" />
      {/* Cab */}
      <path d="M10 33 H18 M30 33 H52 L52 19 L46 10 C44 8 42 7 39 7 L22 7 C19 7 17 9 16 11 L12 19 L8 19 C6 19 5 21 5 23 L5 29 C5 31 6 33 8 33" data-id="element-87" data-mp="2qeqped34z8ja" />
      {/* Cab windows */}
      <path d="M17 12 L22 8 L39 8 L44 12 L44 18 L15 18 Z" strokeLinejoin="round" data-id="element-88" data-mp="1xrw6vlpvqj8g" />
      <line x1="32" y1="8" x2="32" y2="18" data-id="element-89" data-mp="22p4sjwa8l5eg" />
      {/* Bed */}
      <path d="M52 33 H72 M84 33 H94 C96 33 97 31 97 29 L97 19 L52 19" data-id="element-90" data-mp="27or84cdjexqf" />
      <line x1="97" y1="19" x2="97" y2="33" data-id="element-91" data-mp="27my0atr6u7gu" />
      {/* Mirror */}
      <path d="M14 16 L11 14 L11 17" data-id="element-92" data-mp="3e4bbh4ul6lws" />
      {/* Door handle */}
      <line x1="28" y1="23" x2="33" y2="23" data-id="element-93" data-mp="3j3o82hb9f7ck" />
      {/* Bed detail */}
      <line x1="60" y1="19" x2="60" y2="33" strokeWidth="0.5" strokeDasharray="2 2" data-id="element-94" data-mp="3j60qevkxjjq5" />
    </svg>,
  Sedan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-95" data-mp="3cpie01wogxqn">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-96" data-mp="3qoqecy4kubwf" />
      <circle cx="22" cy="33" r="3" data-id="element-97" data-mp="3qlm2rfos8dvq" />
      <circle cx="78" cy="33" r="6" data-id="element-98" data-mp="3lo2q2k7qg95w" />
      <circle cx="78" cy="33" r="3" data-id="element-99" data-mp="3lnu8wg4kuhow" />
      {/* Body */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L80 20 L72 12 C69 9 65 8 61 8 L38 8 C34 8 30 10 28 13 L22 20 L12 20 C10 20 8 22 7 24 L6 29 C6 31 7 33 8 33 Z" data-id="element-100" data-mp="3ir4kxmfq9pj" />
      {/* Windows */}
      <path d="M29 14 L36 9 L61 9 L70 14 L70 19 L25 19 Z" strokeLinejoin="round" data-id="element-101" data-mp="d7r5imkhzf6d" />
      <line x1="46" y1="9" x2="46" y2="19" data-id="element-102" data-mp="8b0p1y4s6hkf" />
      <line x1="60" y1="9.5" x2="60" y2="19" data-id="element-103" data-mp="8c238bh3fk6d" />
      {/* Mirror */}
      <path d="M24 18 L21 16 L21 18" data-id="element-104" data-mp="n7hxohll5i3a" />
      {/* Door lines */}
      <line x1="46" y1="19" x2="46" y2="30" data-id="element-105" data-mp="i8okkqa7nt3n" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="41" y2="24" data-id="element-106" data-mp="11tp2vscqjr4e" />
      <line x1="52" y1="24" x2="57" y2="24" data-id="element-107" data-mp="11v07fue092wk" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-108" data-mp="15vsimt6fthvh" />
    </svg>,
  Coupe: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-109" data-mp="rvre93qyrsb9">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-110" data-mp="rxvhrkkyapb0" />
      <circle cx="22" cy="33" r="3" data-id="element-111" data-mp="wtt0fxjos7qy" />
      <circle cx="78" cy="33" r="6" data-id="element-112" data-mp="wsrbqq9qzmqr" />
      <circle cx="78" cy="33" r="3" data-id="element-113" data-mp="i5y66cq15vbr" />
      {/* Body */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L78 20 L68 10 C65 8 60 7 56 7 L38 9 C34 9 30 11 28 14 L22 20 L12 20 C10 20 8 22 7 24 L6 29 C6 31 7 33 8 33 Z" data-id="element-114" data-mp="i44ugj0k8kww" />
      {/* Window - single large */}
      <path d="M30 15 L37 10 L56 8 L66 12 L66 19 L26 19 Z" strokeLinejoin="round" data-id="element-115" data-mp="e44akiuozhig" />
      {/* Mirror */}
      <path d="M25 17 L22 15 L22 17" data-id="element-116" data-mp="3vby8ykreif7w" />
      {/* Door handle */}
      <line x1="42" y1="24" x2="47" y2="24" data-id="element-117" data-mp="45x4iv1xyjv8" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-118" data-mp="4557dfsp4e2u" />
      {/* Rear vent */}
      <line x1="82" y1="22" x2="85" y2="26" strokeWidth="0.8" data-id="element-119" data-mp="3h891as2fzab6" />
    </svg>,
  Convertible: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-120" data-mp="3ceema1xs7jif">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-121" data-mp="37hxwz4euiz3r" />
      <circle cx="22" cy="33" r="3" data-id="element-122" data-mp="37h63q08q1dgn" />
      <circle cx="78" cy="33" r="6" data-id="element-123" data-mp="32i1p2u312nix" />
      <circle cx="78" cy="33" r="3" data-id="element-124" data-mp="32j4f6zsj0lxs" />
      {/* Body - low, no roof */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L20 20 C15 20 10 22 8 25 L6 29 C6 31 7 33 8 33 Z" data-id="element-125" data-mp="40fpwz6wdw4e" />
      {/* Windshield frame */}
      <path d="M30 20 L35 12 L40 12" strokeLinejoin="round" data-id="element-126" data-mp="3q7dxvsug0tkp" />
      {/* Folded top hint */}
      <path d="M60 18 C62 16 65 16 67 18" strokeWidth="0.8" strokeDasharray="2 1" data-id="element-127" data-mp="3q974j8523dsp" />
      {/* Mirror */}
      <path d="M28 18 L25 16 L25 18" data-id="element-128" data-mp="2esh6wdep7uap" />
      {/* Door line */}
      <line x1="48" y1="18" x2="48" y2="30" data-id="element-129" data-mp="2epusbtte4eiz" />
      {/* Door handle */}
      <line x1="38" y1="24" x2="43" y2="24" data-id="element-130" data-mp="29rt5qywr9x2r" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-131" data-mp="pc4w3bhpowlx" />
      {/* Headrest hints */}
      <rect x="42" y="16" width="3" height="4" rx="1" strokeWidth="0.8" data-id="element-132" data-mp="u9evnjyteonh" />
      <rect x="50" y="16" width="3" height="4" rx="1" strokeWidth="0.8" data-id="element-133" data-mp="z9jc59zq3jdp" />
    </svg>,
  Luxury: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-134" data-mp="13zq0d8qbp1vf">
      {/* Wheels */}
      <circle cx="20" cy="33" r="6" data-id="element-135" data-mp="141sykg1mq1b8" />
      <circle cx="20" cy="33" r="3" data-id="element-136" data-mp="18zufovfhvqk2" />
      <line x1="17" y1="33" x2="23" y2="33" strokeWidth="0.5" data-id="element-137" data-mp="18yt48pukh21t" />
      <line x1="20" y1="30" x2="20" y2="36" strokeWidth="0.5" data-id="element-138" data-mp="1czwij7wyuq0x" />
      <circle cx="80" cy="33" r="6" data-id="element-139" data-mp="1hzr91actxdlg" />
      <circle cx="80" cy="33" r="3" data-id="element-140" data-mp="1i0sm1kdeoa5t" />
      <line x1="77" y1="33" x2="83" y2="33" strokeWidth="0.5" data-id="element-141" data-mp="1hxo9nzpse842" />
      <line x1="80" y1="30" x2="80" y2="36" strokeWidth="0.5" data-id="element-142" data-mp="1mxst9ylzriyi" />
      {/* Body - long elegant */}
      <path d="M6 33 H14 M26 33 H74 M86 33 H94 C96 33 97 31 97 29 L95 23 C94 21 92 20 90 20 L82 20 L74 12 C71 9 67 8 63 8 L36 8 C32 8 28 10 26 13 L20 20 L10 20 C8 20 6 22 5 24 L4 29 C4 31 5 33 6 33 Z" data-id="element-143" data-mp="3js5nfzg5zzx4" />
      {/* Windows - 3 sections */}
      <path d="M27 14 L34 9 L63 9 L72 14 L72 19 L23 19 Z" strokeLinejoin="round" data-id="element-144" data-mp="1uga5icl95bv6" />
      <line x1="42" y1="9" x2="42" y2="19" data-id="element-145" data-mp="1ph789ebik9xr" />
      <line x1="56" y1="9.5" x2="56" y2="19" data-id="element-146" data-mp="248fxhmbi7tad" />
      <line x1="64" y1="9" x2="64" y2="19" data-id="element-147" data-mp="24a92yyads7gs" />
      {/* Chrome trim line */}
      <line x1="8" y1="26" x2="92" y2="26" strokeWidth="0.8" data-id="element-148" data-mp="1z9lf2lhg86qs" />
      {/* Mirror */}
      <path d="M22 18 L19 16 L19 18" data-id="element-149" data-mp="1bkjzmea77vc0" />
      {/* Door handles */}
      <line x1="34" y1="23" x2="38" y2="23" data-id="element-150" data-mp="16knw0g5ey5wz" />
      <line x1="50" y1="23" x2="54" y2="23" data-id="element-151" data-mp="16lphlek22asy" />
    </svg>,
  SportsCar: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-152" data-mp="1liq1wwzx33he">
      {/* Wheels */}
      <circle cx="22" cy="34" r="6" data-id="element-153" data-mp="1givamsc8cbvt" />
      <circle cx="22" cy="34" r="3" data-id="element-154" data-mp="1ghsmuta7epk4" />
      <circle cx="78" cy="34" r="6" data-id="element-155" data-mp="1gkya02z9vhd7" />
      <circle cx="78" cy="34" r="3" data-id="element-156" data-mp="2ww2bloicygbh" />
      {/* Body - very low aggressive */}
      <path d="M8 34 H16 M28 34 H72 M84 34 H94 C96 34 97 32 97 30 L95 25 C94 23 92 22 90 22 L80 22 L72 15 C69 12 64 10 60 10 L40 12 C36 12 32 14 30 17 L24 22 L12 22 C10 22 8 24 7 26 L6 30 C6 32 7 34 8 34 Z" data-id="element-157" data-mp="2ry0qyz5aa8xw" />
      {/* Window - fastback style */}
      <path d="M32 18 L39 13 L58 11 L70 16 L70 21 L28 21 Z" strokeLinejoin="round" data-id="element-158" data-mp="34hxqlbu72kg4" />
      {/* Mirror */}
      <path d="M27 20 L24 18 L24 20" data-id="element-159" data-mp="2qiy2c5alg7kh" />
      {/* Air intake */}
      <path d="M10 28 L14 26" strokeWidth="0.8" data-id="element-160" data-mp="2uiyhjs5iomsl" />
      <path d="M86 28 L90 26" strokeWidth="0.8" data-id="element-161" data-mp="3i7rd3ni88smo" />
      {/* Door handle */}
      <line x1="44" y1="25" x2="48" y2="25" data-id="element-162" data-mp="3i9uf75wnmc7r" />
      {/* Spoiler hint */}
      <path d="M88 22 L92 20 L92 22" strokeWidth="0.8" data-id="element-163" data-mp="3n5j8wslzsyw5" />
    </svg>,
  Minivan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-164" data-mp="39eeb7w26qgog">
      {/* Wheels */}
      <circle cx="22" cy="34" r="6" data-id="element-165" data-mp="3dgj4gtoq1bak" />
      <circle cx="22" cy="34" r="3" data-id="element-166" data-mp="3dfht0o3smmsb" />
      <circle cx="78" cy="34" r="6" data-id="element-167" data-mp="5198827ij0ap" />
      <circle cx="78" cy="34" r="3" data-id="element-168" data-mp="506i3wi0l1vu" />
      {/* Body - tall boxy */}
      <path d="M8 34 H16 M28 34 H72 M84 34 H92 C94 34 95 32 95 30 L95 12 C95 9 93 7 90 7 L30 7 C26 7 22 9 20 12 L14 20 L8 20 C6 20 5 22 5 24 L5 30 C5 32 6 34 8 34 Z" data-id="element-169" data-mp="9rpkvk3iehw0" />
      {/* Windows - large greenhouse */}
      <path d="M22 13 L28 8 L90 8 L90 18 L18 18 Z" strokeLinejoin="round" data-id="element-170" data-mp="1o6yylkaheb53" />
      <line x1="40" y1="8" x2="40" y2="18" data-id="element-171" data-mp="1o42zvtqt7ifl" />
      <line x1="58" y1="8" x2="58" y2="18" data-id="element-172" data-mp="1984xhtqalhux" />
      <line x1="75" y1="8" x2="75" y2="18" data-id="element-173" data-mp="19b9btjxh1tzb" />
      {/* Roof rails */}
      <line x1="28" y1="5" x2="88" y2="5" strokeWidth="0.8" data-id="element-174" data-mp="1e6ojtv8ssvnt" />
      {/* Sliding door line */}
      <line x1="58" y1="18" x2="58" y2="31" data-id="element-175" data-mp="10g2zs37lyfoc" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="40" y2="24" data-id="element-176" data-mp="15831o178nink" />
      <line x1="64" y1="24" x2="68" y2="24" data-id="element-177" data-mp="158w44pz5zlzw" />
      {/* Mirror */}
      <path d="M17 17 L14 15 L14 17" data-id="element-178" data-mp="qjq4x20btvs0" />
    </svg>,
  Wagon: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-179" data-mp="vhi8itac36c1">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-180" data-mp="vff9jjr7e2v6" />
      <circle cx="22" cy="33" r="3" data-id="element-181" data-mp="hhh08srqowmj" />
      <circle cx="78" cy="33" r="6" data-id="element-182" data-mp="hiihxg39ghd8" />
      <circle cx="78" cy="33" r="3" data-id="element-183" data-mp="ljkjw4okb7iw" />
      {/* Body - sedan with extended flat roof */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L95 12 C95 10 93 9 91 9 L62 9 C58 9 54 10 52 12 L28 13 C25 13 22 14 20 16 L14 20 L10 20 C8 20 6 22 6 24 L5 29 C5 31 6 33 8 33 Z" data-id="element-184" data-mp="llew8ulrprbd" />
      {/* Windows */}
      <path d="M29 14 L36 10 L62 10 L90 10 L90 19 L24 19 Z" strokeLinejoin="round" data-id="element-185" data-mp="bvq89j74x93h" />
      <line x1="46" y1="10" x2="46" y2="19" data-id="element-186" data-mp="6wdioqovpnx7" />
      <line x1="62" y1="10" x2="62" y2="19" data-id="element-187" data-mp="6vk8ffqpogab" />
      <line x1="78" y1="10" x2="78" y2="19" data-id="element-188" data-mp="ltw3jhyfrgzd" />
      {/* Roof rails */}
      <line x1="34" y1="7" x2="88" y2="7" strokeWidth="0.8" data-id="element-189" data-mp="lrt6idyv8nl5" />
      {/* Mirror */}
      <path d="M23 17 L20 15 L20 17" data-id="element-190" data-mp="gut0u45xhmuk" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="40" y2="24" data-id="element-191" data-mp="ulek3tzanysz" />
      <line x1="52" y1="24" x2="56" y2="24" data-id="element-192" data-mp="uokdhleyhmui" />
      {/* Trim line */}
      <line x1="10" y1="27" x2="90" y2="27" strokeWidth="0.5" data-id="element-193" data-mp="qle7mevr9xok" />
    </svg>,
  Hatchback: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-194" data-mp="14l5gk17f0nvp">
      {/* Wheels */}
      <circle cx="24" cy="33" r="6" data-id="element-195" data-mp="zmc2o7o7uuv0" />
      <circle cx="24" cy="33" r="3" data-id="element-196" data-mp="zndo962uyzqz" />
      <circle cx="76" cy="33" r="6" data-id="element-197" data-mp="3tdsi3veq7r94" />
      <circle cx="76" cy="33" r="3" data-id="element-198" data-mp="3tetuc37hajsf" />
      {/* Body - compact, sloped rear */}
      <path d="M10 33 H18 M30 33 H70 M82 33 H90 C92 33 93 31 93 29 L90 20 C89 19 88 18 86 18 L78 18 L70 10 C68 8 65 7 62 7 L38 8 C34 8 30 10 28 13 L22 18 L14 18 C12 18 10 20 9 22 L8 29 C8 31 9 33 10 33 Z" data-id="element-199" data-mp="18yfs18tem4x" />
      {/* Windows */}
      <path d="M30 14 L36 9 L62 8 L68 12 L68 17 L26 17 Z" strokeLinejoin="round" data-id="element-200" data-mp="b145f4blgrgy" />
      <line x1="48" y1="8.5" x2="48" y2="17" data-id="element-201" data-mp="fy4ezp7nkcct" />
      {/* Rear hatch angle */}
      <path d="M78 18 L86 18" data-id="element-202" data-mp="kwnvvb7e2xyb" />
      {/* Mirror */}
      <path d="M25 16 L22 14 L22 16" data-id="element-203" data-mp="ozaupw2h9j50" />
      {/* Door line */}
      <line x1="48" y1="17" x2="48" y2="30" data-id="element-204" data-mp="ozu1cgmogl3q" />
      {/* Door handles */}
      <line x1="36" y1="23" x2="40" y2="23" data-id="element-205" data-mp="txcdsgzwligh" />
      <line x1="54" y1="23" x2="58" y2="23" data-id="element-206" data-mp="twaz82joidu0" />
      {/* Trim line */}
      <line x1="12" y1="26" x2="86" y2="26" strokeWidth="0.5" data-id="element-207" data-mp="2qryz48quycmd" />
    </svg>,
  CargoVan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-208" data-mp="2vqjsbo7ozw1b">
      {/* Wheels */}
      <circle cx="20" cy="35" r="5" data-id="element-209" data-mp="2o6iwb9nkh9y4" />
      <circle cx="20" cy="35" r="2.5" data-id="element-210" data-mp="2o7k9bjo586ih" />
      <circle cx="80" cy="35" r="5" data-id="element-211" data-mp="2jfsta32m5j6l" />
      <circle cx="80" cy="35" r="2.5" data-id="element-212" data-mp="2jer3stkuou5c" />
      {/* Body - tall commercial van */}
      <path d="M8 35 H15 M25 35 H75 M85 35 H94 C96 35 97 33 97 31 L97 8 C97 6 95 5 93 5 L35 5 C32 5 29 6 27 8 L18 18 L8 18 C6 18 4 20 4 22 L4 31 C4 33 5 35 8 35 Z" data-id="element-213" data-mp="2efob88m24ge9" />
      {/* Cab window */}
      <path d="M20 10 L26 6 L35 6 L35 16 L16 16 Z" strokeLinejoin="round" data-id="element-214" data-mp="375n289jtanlk" />
      {/* Cargo area - large panel */}
      <path d="M35 5 L35 35" data-id="element-215" data-mp="327236dgaq9yp" />
      {/* Cargo door */}
      <line x1="65" y1="8" x2="65" y2="32" strokeWidth="0.8" data-id="element-216" data-mp="3247f8by2q70j" />
      {/* Door handle on cargo */}
      <line x1="63" y1="20" x2="67" y2="20" data-id="element-217" data-mp="2x8s802ukn9d3" />
      {/* Van nose detail */}
      <path d="M8 18 L4 22" data-id="element-218" data-mp="2t52m5l5a75vr" />
      {/* Rear door lines */}
      <rect x="88" y="10" width="7" height="22" rx="1" strokeWidth="0.5" data-id="element-219" data-mp="1ls0skz4cjzu9" />
      {/* Mirror */}
      <path d="M15 15 L12 13 L12 16" data-id="element-220" data-mp="1hpxfk6214n6v" />
      {/* Front bumper */}
      <line x1="5" y1="30" x2="10" y2="30" strokeWidth="0.8" data-id="element-221" data-mp="1hsjjlvppokkc" />
    </svg>,
  Hybrid: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-222" data-mp="35l1xnpw1mjgw">
      {/* Leaf shape - circular */}
      <path d="M50 8 C38 8 30 16 30 26 C30 34 38 38 50 38 C62 38 68 30 68 22 C68 14 62 8 50 8 Z" strokeLinejoin="round" data-id="element-223" data-mp="3afoe47gzf27u" />
      {/* Leaf vein / stem diagonal */}
      <path d="M36 36 L50 22 L64 10" data-id="element-224" data-mp="30o1t5jeudorw" />
      {/* Small leaf detail veins */}
      <path d="M44 28 L50 22" strokeWidth="0.8" data-id="element-225" data-mp="3oee6xawrqfqe" />
      <path d="M50 22 L56 16" strokeWidth="0.8" data-id="element-226" data-mp="3objm3i9ueswg" />
    </svg>,
  Electric: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-227" data-mp="3tad33koc921d">
      {/* Lightning bolt - bold */}
      <path d="M56 4 L38 22 L48 22 L44 40 L62 22 L52 22 Z" strokeLinejoin="round" strokeWidth="2" data-id="element-228" data-mp="3fceteskypts7" />
    </svg>,
  PHEV: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-229" data-mp="23x9lna5z551q">
      {/* Plug prongs */}
      <line x1="44" y1="4" x2="44" y2="14" strokeWidth="2" strokeLinecap="round" data-id="element-230" data-mp="27yuxqtaopfav" />
      <line x1="56" y1="4" x2="56" y2="14" strokeWidth="2" strokeLinecap="round" data-id="element-231" data-mp="20eai8tl9fwrj" />
      {/* Plug body */}
      <rect x="38" y="14" width="24" height="12" rx="3" data-id="element-232" data-mp="2adhu1cccjjcj" />
      {/* Cord */}
      <line x1="50" y1="26" x2="50" y2="32" strokeWidth="2" data-id="element-233" data-mp="2abf8p5m52ee5" />
      <path d="M50 32 C50 36 46 38 42 38" strokeWidth="2" strokeLinecap="round" data-id="element-234" data-mp="25fzv8es1mki9" />
    </svg>,
  Diesel: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-235" data-mp="1cq12a8aqa38b">
      {/* Fuel drop shape */}
      <path d="M50 6 C50 6 36 20 36 28 C36 35.7 42.3 42 50 42 C57.7 42 64 35.7 64 28 C64 20 50 6 50 6 Z" strokeLinejoin="round" data-id="element-236" data-mp="1cnwpt1yrjvwf" />
      {/* Letter D */}
      <path d="M46 24 L46 34 L50 34 C54 34 56 31 56 29 C56 27 54 24 50 24 Z" strokeLinejoin="round" data-id="element-237" data-mp="1mmm82vuknid7" />
    </svg>
};
const carTypes = [{
  name: 'SUVs',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/aiidpgUWsHhnMgc5MjoD7N/Captura_de_pantalla_2026-03-30_a_la(s)_11.39.39_p._m..png" alt="SUV" className="w-full h-[80px] object-contain" data-id="element-238" data-mp="tz04vop9afqv" />
}, {
  name: 'Camionetas',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/erVwCv4HA3dRafd8916c1H/Captura_de_pantalla_2026-03-30_a_la(s)_11.44.51_p._m..png" alt="Camioneta" className="w-full h-[80px] object-contain" data-id="element-239" data-mp="1sh0e8y32g04z" />
}, {
  name: 'Sedanes',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/t9pfnk2bNgHKyvcKHbs2Wd/Captura_de_pantalla_2026-03-30_a_la(s)_11.48.21_p._m..png" alt="Sedán" className="w-full h-[80px] object-contain" data-id="element-240" data-mp="14pv0cogorhxb" />
}, {
  name: 'Coupés',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/bLbyMzitZ8mRW8C9gun8Up/Captura_de_pantalla_2026-03-30_a_la(s)_11.48.21_p._m..png" alt="Coupé" className="w-full h-[80px] object-contain" data-id="element-241" data-mp="2l4mryz60cl5k" />
}, {
  name: 'Convertibles',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/rd8pNuKrJGkyjZNYnqsWvk/Captura_de_pantalla_2026-03-31_a_la(s)_12.09.49_a._m..png" alt="Convertible" className="w-full h-[80px] object-contain" data-id="element-242" data-mp="eigum8tur0jh" />
}, {
  name: 'Lujo',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/cJFDpZJYDwEyKUf7XhEARt/Captura_de_pantalla_2026-03-31_a_la(s)_12.10.30_a._m..png" alt="Lujo" className="w-full h-[80px] object-contain" data-id="element-243" data-mp="3vwlvi7ygidkj" />
}, {
  name: 'Deportivos',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/gVu7uZT9Lbvo1N9yVR295P/Captura_de_pantalla_2026-03-31_a_la(s)_12.11.28_a._m..png" alt="Deportivo" className="w-full h-[80px] object-contain" data-id="element-244" data-mp="3hxvystfjufwp" />
}, {
  name: 'Hatchbacks',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/71L7LPgNNq5zKjzsS6h6DN/Captura_de_pantalla_2026-03-31_a_la(s)_12.13.41_a._m..png" alt="Hatchback" className="w-full h-[80px] object-contain" data-id="element-245" data-mp="1b6ephcpy73qs" />
}, {
  name: 'Utilitarios',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/2pexmrLiphfnznyFWhr3kh/Captura_de_pantalla_2026-03-31_a_la(s)_12.18.21_a._m..png" alt="Utilitario" className="w-full h-[80px] object-contain" data-id="element-246" data-mp="b9ijojkfnkx6" />
}];
interface CarTypeCarouselProps {
  selectedType?: string | null;
  onSelectType?: (type: string | null) => void;
}
export function CarTypeCarousel({
  selectedType,
  onSelectType
}: CarTypeCarouselProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <div className="bg-[#1A1C17] rounded-2xl p-6 mb-8 relative overflow-hidden border-2 border-[#C9A24E]" data-id="element-247" data-mp="1qnene5s5hl96">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-248" data-mp="376q2sh3nhkl0">
        <div className="flex items-center gap-3" data-id="element-249" data-mp="3743n1u6lvyrp">
          <svg className="w-6 h-6 text-[#F2F0E9]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-250" data-mp="3kxuyx97t7uql">
            <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" data-id="element-251" data-mp="3pwob8ybd1fp6" />
            <circle cx="7" cy="17" r="2" data-id="element-252" data-mp="7op011ze78p8" />
            <path d="M9 17h6" data-id="element-253" data-mp="2t1d6t8durmw" />
            <circle cx="17" cy="17" r="2" data-id="element-254" data-mp="2srkgxvye6di" />
          </svg>
          <h2 className="text-lg text-[#F2F0E9]" data-id="element-255" data-mp="29hmqws9lzr7j">
            ¿Qué <span className="font-bold" data-id="element-256" data-mp="29k97fheh9h1w">tipo</span> de auto querés?
          </h2>
        </div>

        {/* Navigation Arrows */}
        <div className="flex items-center gap-2" data-id="element-257" data-mp="1cuciv9mqxskv">
          <button onClick={() => scroll('left')} aria-label="Ver tipos anteriores" className="w-10 h-10 rounded-full bg-[#2B2E27] border-2 border-[#C9A24E] flex items-center justify-center text-[#F2F0E9] hover:bg-[#C9A24E] hover:text-[#1A1C17] transition-colors shadow-sm" data-id="element-258" data-mp="1ct1hthkoqyxg">
            <ChevronLeft className="w-5 h-5" data-id="element-259" data-mp="1hnyoihuhsw76" />
          </button>
          <button onClick={() => scroll('right')} aria-label="Ver más tipos" className="w-10 h-10 rounded-full bg-[#2B2E27] border-2 border-[#C9A24E] flex items-center justify-center text-[#F2F0E9] hover:bg-[#C9A24E] hover:text-[#1A1C17] transition-colors shadow-sm" data-id="element-260" data-mp="twjr93hkp52s">
            <ChevronRight className="w-5 h-5" data-id="element-261" data-mp="xzpvk5l4km6m" />
          </button>
        </div>
      </div>

      {/* Carousel Cards */}
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide -mx-2 px-2" data-id="element-262" data-mp="29cscj1r4zdrb">
        {carTypes.map((type, index) => {
        const isActive = selectedType === type.name;
        return <button key={index} onClick={() => onSelectType?.(isActive ? null : type.name)} className={`flex-shrink-0 w-[160px] h-[130px] rounded-xl border-2 shadow-sm transition-colors duration-200 flex flex-col items-center justify-between pt-3 pb-3 group ${isActive ? 'bg-[#C9A24E] border-[#C9A24E] shadow-md' : 'bg-[#DAD8D0] border-[#C9A24E]/50 hover:border-[#C9A24E]'}`} data-id="element-263" data-mp="2lwfingvsmzz3" data-mpi={index}>
              <div className="flex-1 flex items-center justify-center w-32 group-hover:scale-105 transition-transform duration-300" data-id="element-264" data-mp="35ik6j7vj04xs">
                <type.Icon data-id="element-265" data-mp="2vtah5zs2h0dd" />
              </div>
              <span className={`text-[15px] ${isActive ? 'text-[#1A1C17] font-bold' : 'text-[#3A3D36] font-medium'}`} data-id="element-266" data-mp="2vrzddzymfsm9">
                {type.name}
              </span>
            </button>;
      })}
      </div>
    </div>;
}